import type { KeyboardEvent } from "react";

// TODO Update types inside Frui.ts
export const onNumberInputKeyPress = (event: KeyboardEvent<any> | any) => {
  if (["+", "-", "e"].includes(event.key)) {
    event.preventDefault();
  }
};
